var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "emd-context-select" }, [
    _c("header", { staticClass: "emd-context-select__header" }, [
      _c("nav", { staticClass: "emd-segmented-controls" }, [
        _c(
          "button",
          {
            staticClass: "emd-segmented-controls__item",
            class: { _active: _vm.activeSegment === "production" },
            on: {
              click: function ($event) {
                return _vm.toggleSegment("production")
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("segment.prd")) + " ")]
        ),
        _c(
          "button",
          {
            staticClass: "emd-segmented-controls__item _warning",
            class: { _active: _vm.activeSegment === "test" },
            on: {
              click: function ($event) {
                return _vm.toggleSegment("test")
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("segment.tst")) + " ")]
        ),
      ]),
    ]),
    _c(
      "main",
      { staticClass: "emd-context-select__body" },
      [
        _c(
          "keep-alive",
          [
            _vm.merchant && _vm.account
              ? _c(_vm.activeSegmentPartial, {
                  tag: "component",
                  attrs: { merchant: _vm.merchant, account: _vm.account },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }